import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';

export class TeamName extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['develop', 'teamwork'];
  }

  static subqueriesForModel() {
    return { team: ['name'] };
  }

  get title() {
    return 'Team name';
  }

  exampleContents(): FieldContentsData {
    return { text: 'Development team' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.team) {
      return { text: record.team.name };
    }

    return {};
  }
}
